<!-- eteams管理添加/修改弹窗 -->
<template>
  <el-dialog
    title="365资产设备型号"
    :visible.sync="dialogVisible"
    width="550px"
    @open="open"
    @closed="handleClose"
  >
    <el-form :model="form" ref="form" label-width="120px">
      <el-form-item label="资产类型编码：" prop="code">
        <el-input v-model="form.code" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="资产类型名称：" prop="name">
        <el-input v-model="form.name" placeholder=""></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { add, edit } from "../api/eteams";
export default {
  name: "eteamsOper",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {
        code: "",
        name: "",
      },
    };
  },
  methods: {
    open() {
      if (JSON.stringify(this.current) != "{}") {
        this.form.code = this.current.code;
        this.form.name = this.current.name;
      } else {
        this.form = {
          code: "",
          name: "",
        };
      }
    },
    submit() {
      if (JSON.stringify(this.current) == "{}") {
        add(this.form).then((data) => {
          if (data.data.code == 100000) {
            this.$message.success(data.data.msg);
            this.$emit("refresh");
            this.dialogVisible = false;
          } else {
            this.$message.error(data.data.msg);
          }
        });
      } else {
        let params = { ...this.form };
        params.id = this.current.id;
        edit(params).then((data) => {
          if (data.data.code == 100000) {
            this.$message.success(data.data.msg);
            this.$emit("refresh");
            this.dialogVisible = false;
          } else {
            this.$message.error(data.data.msg);
          }
        });
      }
    },
    handleClose() {
      this.$refs.form.resetFields();
    },
  },
  watch: {
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
    visible(val) {
      this.dialogVisible = val;
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped></style>
